// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Fkyc","rightAdornment":"Header_rightAdornment__1VlTF"};